export default __webpack_public_path__ + "static/media/lamp.545f53d7.gif";